/**
 * Toast Component - уведомления
 */

import React, { useEffect } from "react";

const Toast = ({
    message,
    type = "success", // success | error | warning | info
    duration = 3000,
    className = "",
}) => {
    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(duration);
            return () => clearTimeout(timer);
        }
    }, [duration]);

    const baseClass = "toast";
    const classes = [baseClass, `${baseClass}--${type}`, className]
        .filter(Boolean)
        .join(" ");

    return (
        <div
            className={classes}
            role="alert"
            style={{ "--toast-duration": `${duration}ms` }}
        >
            <span className={`${baseClass}__message`}>{message}</span>
        </div>
    );
};

export default Toast;
